import { ElementRef } from '@angular/core';
import { InviteFriendModalComponent } from 'AccountsApp/ts/features/invite-friend-modal/invite-friend-modal.component';
import { isDesktop } from 'NewAngular/utils/media';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../directives/icon/icon.directive";
import * as i3 from "../../../../../../../apps/accounts/static/accounts/ts/features/invite-friend-modal/invite-friend-modal.component";
const _c0 = ["navMenuListDiv"];
const _c1 = (a0, a1) => ({ show: a0, dropdown: a1 });
const _c2 = a0 => ({ show: a0 });
const _c3 = a0 => ({ "dropdown-toggle": a0 });
function NavMenuListComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 13);
    i0.ɵɵlistener("click", function NavMenuListComponent_a_2_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clickHandler()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r1.config.href, i0.ɵɵsanitizeUrl)("ngClass", i0.ɵɵpureFunction1(3, _c3, !!ctx_r1.config.columns))("textContent", ctx_r1.config.title);
} }
function NavMenuListComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 14);
    i0.ɵɵlistener("click", function NavMenuListComponent_a_3_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clickHandler()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, !!ctx_r1.config.columns))("textContent", ctx_r1.config.title);
} }
function NavMenuListComponent_div_10_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 22);
} }
function NavMenuListComponent_div_10_ng_container_4_ng_container_2__svg_svg_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 26);
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("name", listItem_r4.iconName);
} }
function NavMenuListComponent_div_10_ng_container_4_ng_container_2__svg_svg_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 26);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-new");
} }
function NavMenuListComponent_div_10_ng_container_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 23)(2, "div", 24);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NavMenuListComponent_div_10_ng_container_4_ng_container_2__svg_svg_4_Template, 1, 1, "svg", 25)(5, NavMenuListComponent_div_10_ng_container_4_ng_container_2__svg_svg_5_Template, 1, 1, "svg", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const listItem_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", listItem_r4.href, i0.ɵɵsanitizeUrl)("target", (listItem_r4 == null ? null : listItem_r4.newTab) ? "_blank" : "_self");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(listItem_r4.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", listItem_r4.iconName && !listItem_r4.isNew);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", listItem_r4.isNew);
} }
function NavMenuListComponent_div_10_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 19);
    i0.ɵɵtemplate(1, NavMenuListComponent_div_10_ng_container_4_div_1_Template, 1, 0, "div", 20)(2, NavMenuListComponent_div_10_ng_container_4_ng_container_2_Template, 6, 5, "ng-container", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const listItem_r4 = ctx.$implicit;
    i0.ɵɵproperty("ngSwitch", listItem_r4.type);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "divider");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "option");
} }
function NavMenuListComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16)(2, "div", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NavMenuListComponent_div_10_ng_container_4_Template, 3, 3, "ng-container", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const column_r5 = ctx.$implicit;
    i0.ɵɵclassMap(column_r5.class);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(column_r5.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", column_r5.list);
} }
function NavMenuListComponent_div_11_a_5_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 33);
} if (rf & 2) {
    const link_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r1.config.content.image, i0.ɵɵsanitizeUrl)("alt", link_r6.title);
} }
function NavMenuListComponent_div_11_a_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 31)(1, "div");
    i0.ɵɵtemplate(2, NavMenuListComponent_div_11_a_5_img_2_Template, 1, 2, "img", 32);
    i0.ɵɵelementStart(3, "div", 24);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const link_r6 = ctx.$implicit;
    const first_r7 = ctx.first;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", link_r6.href, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", first_r7 && ctx_r1.config.content.image);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(link_r6.title);
} }
function NavMenuListComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27)(1, "div", 16)(2, "div", 28)(3, "div", 29);
    i0.ɵɵtext(4, "Featured Content");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, NavMenuListComponent_div_11_a_5_Template, 5, 3, "a", 30);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r1.config.content.links);
} }
function NavMenuListComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34)(1, "div", 16)(2, "p", 24);
    i0.ɵɵtext(3, "Know someone who will enjoy YCharts?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a", 35);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 36);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7, "Refer a Friend");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 37);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("name", "icon-friend");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-go");
} }
/**
 *
 * Nav Menu List Component
 *
 * Component for main menu drop down items.
 *
 * Required Attributes:
 *  config: Object representing the menu structure.
 */
export class NavMenuListComponent {
    constructor() {
        this.show = false;
        this.USER = window.USER;
    }
    ngAfterViewInit() {
        // cover case for landscape tablet.
        this.navMenuListDiv.nativeElement.addEventListener('touchstart', this.toggleShow, { passive: true });
    }
    clickHandler() {
        // rely on hover to show/hide menu for desktop.
        if (!isDesktop()) {
            this.toggleShow();
        }
    }
    toggleShow() {
        this.show = !this.show;
    }
    showInviteFriendModal() {
        this.ifmc.openModal();
    }
}
NavMenuListComponent.ɵfac = function NavMenuListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NavMenuListComponent)(); };
NavMenuListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NavMenuListComponent, selectors: [["ycn-nav-menu-list"]], viewQuery: function NavMenuListComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(InviteFriendModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.navMenuListDiv = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ifmc = _t.first);
    } }, inputs: { config: "config" }, standalone: false, decls: 14, vars: 12, consts: [["navMenuListDiv", ""], [1, "header-mainmenu-item", 3, "ngClass"], ["class", "header-mainmenu-link", 3, "href", "ngClass", "textContent", "click", 4, "ngIf"], ["class", "header-mainmenu-link", "href", "javascript:void(0)", 3, "ngClass", "textContent", "click", 4, "ngIf"], [1, "dropdown-menu", "dropdown-menu-data", 3, "ngClass"], [1, "header-container", "container"], [1, "header-logo-wrap"], ["href", "/", 1, "header-logo"], ["alt", "YCharts logo", "src", "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='155px' height='21px' viewBox='-0.195 0 155 21' enable-background='new -0.195 0 155 21' xml:space='preserve'%3E%3Cpolygon fill='%230282E8' points='14.863,0.358 7.823,12.352 7.823,20.428 12.214,20.428 12.214,12.614 19.939,0.358 '/%3E%3Cpolygon fill='%230282E8' points='8.034,5.392 5.044,0.358 -0.195,0.358 5.697,9.646 '/%3E%3Cpath fill='%23FFFFFF' d='M32.348,21c-5.975,0-10.413-4.609-10.413-10.441V10.5c0-5.77,4.354-10.5,10.588-10.5 c3.831,0,6.121,1.278,8.008,3.133l-2.845,3.279c-1.565-1.422-3.16-2.292-5.189-2.292c-3.423,0-5.888,2.843-5.888,6.323V10.5 c0,3.48,2.406,6.382,5.888,6.382c2.32,0,3.742-0.929,5.336-2.377l2.844,2.872C38.587,19.607,36.264,21,32.348,21'/%3E%3Cpolygon fill='%23FFFFFF' points='59.338,20.65 59.338,12.502 51.1,12.502 51.1,20.65 46.633,20.65 46.633,0.35 51.1,0.35 51.1,8.383 59.338,8.383 59.338,0.35 63.805,0.35 63.805,20.65 '/%3E%3Cpath fill='%23FFFFFF' d='M79.625,5.57l-2.694,6.584h5.39L79.625,5.57z M85.772,20.65l-1.854-4.553h-8.585l-1.858,4.553h-4.553 l8.699-20.446h4.119L90.44,20.65H85.772z'/%3E%3Cpath fill='%23FFFFFF' d='M107.926,7.281c0-1.914-1.333-2.901-3.511-2.901h-4.438v5.829h4.523c2.177,0,3.423-1.161,3.423-2.872 L107.926,7.281L107.926,7.281z M107.839,20.65l-4.353-6.496h-3.511v6.496H95.51V0.35h9.28c4.788,0,7.656,2.523,7.656,6.7v0.06 c0,3.276-1.771,5.335-4.352,6.294l4.96,7.25h-5.223V20.65H107.839z'/%3E%3Cpolygon fill='%23FFFFFF' points='128.369,4.467 128.369,20.65 123.903,20.65 123.903,4.467 117.723,4.467 117.723,0.35 134.548,0.35 134.548,4.467 '/%3E%3Cpath fill='%23FFFFFF' d='M146.962,20.941c-3.074,0-6.18-1.073-8.612-3.248l2.642-3.161c1.823,1.509,3.74,2.465,6.062,2.465 c1.828,0,2.932-0.726,2.932-1.915v-0.059c0-1.131-0.696-1.713-4.09-2.582c-4.091-1.043-6.729-2.173-6.729-6.207V6.179 c0-3.682,2.957-6.12,7.103-6.12c2.963,0,5.481,0.927,7.543,2.579l-2.318,3.366c-1.804-1.248-3.567-2-5.277-2 c-1.714,0-2.612,0.782-2.612,1.769v0.059c0,1.333,0.871,1.77,4.379,2.668c4.119,1.074,6.44,2.553,6.44,6.092v0.061 C154.417,18.682,151.344,20.941,146.962,20.941'/%3E%3C/svg%3E", 1, "invisible"], [1, "row", "wide-gutters"], ["class", "col", 3, "class", 4, "ngFor", "ngForOf"], ["class", "col-auto flex-auto mainmenu-featured order-md-5", 4, "ngIf"], ["class", "col-auto mainmenu-refer visible-md-block hidden-lg visible-xl-block order-md-6", 4, "ngIf"], [1, "header-mainmenu-link", 3, "click", "href", "ngClass", "textContent"], ["href", "javascript:void(0)", 1, "header-mainmenu-link", 3, "click", "ngClass", "textContent"], [1, "col"], [1, "mainmenu-section"], [1, "mainmenu-section-title"], [3, "ngSwitch", 4, "ngFor", "ngForOf"], [3, "ngSwitch"], ["class", "dropdown-divider", 4, "ngSwitchCase"], [4, "ngSwitchCase"], [1, "dropdown-divider"], [1, "mainmenu-section-item", 3, "href", "target"], [1, "mainmenu-section-item-text"], ["ycnIcon", "", "class", "flex-none", 3, "name", 4, "ngIf"], ["ycnIcon", "", 1, "flex-none", 3, "name"], [1, "col-auto", "flex-auto", "mainmenu-featured", "order-md-5"], [1, "pl-12", "border-l", "border-color-gray-40"], [1, "mainmenu-section-title", "text-capitalize"], ["class", "mainmenu-section-item", 3, "href", 4, "ngFor", "ngForOf"], [1, "mainmenu-section-item", 3, "href"], ["class", "mb-1", "width", "120", "fetchpriority", "low", "loading", "lazy", 3, "src", "alt", 4, "ngIf"], ["width", "120", "fetchpriority", "low", "loading", "lazy", 1, "mb-1", 3, "src", "alt"], [1, "col-auto", "mainmenu-refer", "visible-md-block", "hidden-lg", "visible-xl-block", "order-md-6"], ["href", "https://go.ycharts.com/referrals-2025?utm_source=Refer_a_Friend&utm_medium=Landing_Page&utm_campaign=Referrals_2025&utm_content=Support", "target", "_blank", 1, "btn", "btn-primary"], ["ycnIcon", "", "role", "img", 1, "icon-friend", 3, "name"], ["ycnIcon", "", "role", "img", 1, "icon-go", "ml-1", 3, "name"]], template: function NavMenuListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1, 0);
        i0.ɵɵtemplate(2, NavMenuListComponent_a_2_Template, 1, 5, "a", 2)(3, NavMenuListComponent_a_3_Template, 1, 4, "a", 3);
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 5)(6, "div", 6)(7, "a", 7);
        i0.ɵɵelement(8, "img", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 9);
        i0.ɵɵtemplate(10, NavMenuListComponent_div_10_Template, 5, 4, "div", 10)(11, NavMenuListComponent_div_11_Template, 6, 1, "div", 11)(12, NavMenuListComponent_div_12_Template, 9, 2, "div", 12);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(13, "ycn-invite-friend-modal");
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c1, ctx.show, ctx.config.columns));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !!ctx.config.href);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.config.href);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c2, ctx.show));
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", ctx.config.columns);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.config.content && ctx.config.content.links.length > 0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.USER.authenticated);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgSwitch, i1.NgSwitchCase, i2.IconDirective, i3.InviteFriendModalComponent], encapsulation: 2, changeDetection: 0 });
